<template>
  <div
    class="document"
    style="height: 100%"
  >
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Recent Notes
          </div>
        </template>
        <template #actions v-if="recentNotes.length">
            <ul>
              <li class="p-narrow no-border">
                <div class="list-content">
                  <router-link
                    :to="{
                      name: 'PidMasterRecord',
                      query: {
                        retired: isRetired,
                      },
                    }"
                  >
                    <font-awesome-icon
                      :icon="['far', 'angle-double-right']"
                      size="2x"
                      title="View Details"
                    />
                  </router-link>
                </div>
              </li>
            </ul>
        </template>
      </es-header>
    </div>
    <es-loader
      v-if="loading"
      style="margin: 6.5rem"
    />
    <es-exception
      v-else-if="loadingError"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
      margin="3rem"
    />
    <es-exception
      v-else-if="!recentNotes.length"
      exceptionMessage="No Notes for this Person."
      margin="3rem"
    />
    <div
      v-else
      class="content"
    >
      <table class="table is-fullwidth">
        <thead>
          <tr class="padding-left--small">
            <th title="Note Date">
              Note Date
            </th>
            <th title="Type">
              Type
            </th>
            <th title="Note">
              Note
            </th>
          </tr>
        </thead>
        <template>
          <person-profile-recent-notes-overview-row
            v-for="(note, id) in recentNotes"
            :key="id"
            :note="note"
          />
        </template>
      </table>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';

import axios from 'axios';
import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import PersonProfileRecentNotesOverviewRow from '@/components/PersonProfileRecentNotesOverviewRow.vue';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faAngleDoubleRight,
);

export default {
  mixins: [
    PermissionManager,
  ],
  components: {
    EsException,
    EsHeader,
    EsLoader,
    PersonProfileRecentNotesOverviewRow,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    isRetired: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      loadingError: false,
      recentNotes: [],
    };
  },
  async created() {
    await this.onLoad();
  },
  methods: {
    async getNotes() {
      const sort = [{
        field: 'lastUpdateDate',
        order: 'DESC',
      }];
      const params = new URLSearchParams();
      params.append('pageSize', 5);
      params.append('sort', JSON.stringify(sort));
      if (this.hasModule('PRSID:PRPRF:NOTES:VIEW:ADMIN')) {
        params.append('type', 'ADMIN');
      }
      if (this.hasModule('PRSID:PRPRF:NOTES:VIEW:GENERAL')) {
        params.append('type', 'GENERAL');
      }
      if (this.isRetired) {
        return axios.get(`retired-person/${this.id}/notes`, { params });
      }
      return axios.get(`person/${this.id}/notes`, { params });
    },
    async onLoad() {
      this.loading = true;
      this.loadingError = false;
      try {
        const res = await Promise.all([
          this.getNotes(),
        ]);
        this.recentNotes = res[0].data.data;
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="css" scoped>
</style>
